import {
  Headline,
  Dialog,
  FlexRow,
  Title1,
  Body,
  useChameleonTheme,
} from "@petsapp/chameleon";
import { EntitlementsList } from "./entitlements-list";
import { WellnessPlan } from "../types";

export function EntitlementsDialog({
  heading,
  formattedPrice,
  name,
  description,
  entitlements,
  priceRange,
  onCancelDialog,
  showDialog,
}: {
  heading: string;
  formattedPrice: string;
  name: WellnessPlan["name"];
  description: WellnessPlan["description"];
  entitlements: WellnessPlan["entitlements"];
  priceRange: string;
  onCancelDialog(): void;
  showDialog: boolean;
}) {
  // @ts-ignore
  const { chameleon } = useChameleonTheme();
  return (
    <Dialog
      open={showDialog}
      onCancel={onCancelDialog}
      title={name}
      description={description}
      content={() => {
        return (
          <div>
            <Body style={{ color: `${chameleon.color.DarkGrey}` }}>
              {heading}
            </Body>
            <EntitlementsList entitlements={entitlements} />
          </div>
        );
      }}
      maxWidth={"480px"}
      buttons={() => {
        return (
          <FlexRow
            style={{
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
            <FlexRow style={{ alignItems: "baseline", gap: "0.5rem" }}>
              <Title1 textColor={chameleon.color.Primary} marginBottomSize={0}>
                {formattedPrice}
              </Title1>
              <Headline
                textColor={chameleon.color.Grey}
                style={{ textAlign: "right" }}
                marginBottomSize={0}
              >
                {priceRange}
              </Headline>
            </FlexRow>
          </FlexRow>
        );
      }}
    />
  );
}
